import script from "./ReferencesHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesHeader.vue?vue&type=style&index=0&id=b23e8dcc&lang=scss"

const __exports__ = script;

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
